module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Search: ")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredUsers,
      "box": "",
      "chips": "",
      "color": "secondary",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return undefined
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.photoURL
          }
        })]), _vm._v(" "), _c('v-list-tile-content', {
          on: {
            "click": function($event) {
              _vm.pushProfile(data.item.id)
            }
          }
        }, [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _vm._v(" "), _c('v-list-tile-sub-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.group)
          }
        })], 1)]]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5ded84c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts/Search.vue
// module id = 59
// module chunks = 1 11